export default {
  "pl": {
    "unit": {
      "actions": {
        "revokeAccess": "Anuluj dostęp",
        "select": "Wybierz rodzaj",
        "selectOutdoorCategory": "Wybierz przestrzeń zewnętrzną",
        "selectUnit": "Wybierz jednostkę",
        "setCustomer": "Przypisz klienta do:",
        "setVisible": "Udziel dostępu online",
        "submit": "Prześlij"
      },
      "attributes": {
        "address_city": "Miasto",
        "address_country": "Kraj",
        "address_number": "Numer",
        "address_street": "Ulica",
        "address_zip": "Kod pocztowy",
        "amount": "Kwota",
        "bathrooms": "Ilość łazienek",
        "bedrooms": "Liczba sypialni",
        "category": "Rodzaj",
        "category_outdoor": "Przestrzeń zewnętrzna",
        "customer": "Klient",
        "deed_signed_at": "Data sporządzenia aktu",
        "description": "Opis",
        "electricity": "Elektryczność",
        "floor": "Piętro",
        "house_subcategory": "Rodzaj mieszkania",
        "internal_note": "Notatka do użytku wewnętrznego",
        "meter_number": "Liczba liczników",
        "meter_number_electricity": "Liczba liczników prądu",
        "meter_number_gas": "Liczba gazomierzy",
        "meter_number_water": "Liczba wodomierzy",
        "meter_numbers": "Liczby liczników",
        "name": "Nazwa",
        "orientation": "Orientacja",
        "price_value": "Łączna wartość sprzedaży",
        "price_value_construction": "Wartość inwestycji",
        "price_value_construction_existing": "Koszt istniejącej inwestycji",
        "price_value_fees": "Opłaty dla architektów/inżynierów",
        "price_value_land": "Wartość gruntu",
        "quotity": "Część kwoty przelewu",
        "sales_employee": "Przedstawiciel handlowy",
        "status": "Status",
        "surface": "Powierzchnia",
        "surface_outdoor": "Powierzchnia przestrzeni zewnętrznej",
        "total": "Łącznie",
        "vat_percentage": "VAT (%)"
      },
      "house_subtype": {
        "detached": "Dom wolnostojący",
        "rowhouse": "Dom szeregowy",
        "semidetached": "Dom typu bliźniak"
      },
      "labels": {
        "activate": "Aktywuj jednostkę",
        "address": "Adres",
        "areYouSureDeactivate": "Czy na pewno chcesz dezaktywować jednostkę {unit_name}?",
        "bathrooms": "łazienka | łazienki",
        "bedrooms": "sypialnia | sypialnie",
        "deactivate": "Dezaktywuj jednostkę",
        "deactivateMessage": "Klient nadal może się z Tobą komunikować i nadal będzie miał dostęp do wszystkich swoich informacji. Wszystkie inne działania, takie jak tworzenie decyzji, przesyłanie dokumentów, wysyłanie ankiet itp. dla {unit_name} nie będą jednak możliwe.",
        "deactivated": "Dezaktywowany",
        "deedSignedOn": "Data podpisania aktu: {date}",
        "detailed_price": "Szczegółowa cena",
        "email_address_secondary_delivery_content": "otrzymuje e-maile z powiadomieniami jako były drugi kontakt",
        "email_address_secondary_delivery_tip": "Ten klient został pierwotnie dodany jako dodatkowy kontakt do innego klienta, zanim wprowadzono obsługę wielu klientów na jednostkę: ten klient będzie nadal otrzymywać te same wiadomości e-mail z powiadomieniami, co inny klient, jednak tylko ten drugi klient ma dostęp do jednostki/logowania.",
        "existingVatValues": "Niektóre wartości VAT są inne niż 0",
        "export": "Eksportuj {unit}",
        "export_preparing": "Zbieranie danych o jednostce może potrwać kilka sekund.",
        "facing": "Orientacja: {direction}",
        "fromATotal": "Całkowita suma projektu: {total}",
        "general": "Ogólne",
        "howDoesCustomerSeeThis": "W jaki sposób klient widzi swoją jednostkę?",
        "integrationNoCustomerAssigned": "Nie przypisano klientów. Przypisz klientów w: {integration_name}.",
        "internal": "Wewnętrzne",
        "invitationAddEmailAddress": "Aby dać {customer} dostęp do urządzenia, najpierw podaj adres e-mail na stronie kontaktowej klienta.",
        "invitationSentTo": "Klient {customer} wkrótce otrzyma zaproszenie na następujący adres: {email}",
        "maintainerNoCustomerAssigned": "Nie przypisano klienta. Tylko członkowie zespołu z uprawnieniami właściciela mogą przypisać klienta do jednostki.",
        "onFloor": "Na piętrze",
        "price_view": "Widok cen",
        "sales_value": "Wszystkie ceny podano w walucie {currency}",
        "scopes": {
          "invisible": "Brak dostępu do jednostki",
          "visible": "Klient ma dostęp do jednostki"
        },
        "search_unit": "Wyszukaj jednostkę lub klienta...",
        "selectUnit": "Wybierz jednostkę",
        "showUnit": "Pokaż jednostkę",
        "simple_price": "Prosty",
        "toggleDetailedPrice": "Zmień widok ceny",
        "unassigned": "Brak przypisanego klienta",
        "unit": "Brak jednostek | 1 jednostka | Liczba jednostek: {count}",
        "unitLabel": "Jednostka",
        "utilities": "Media"
      },
      "outdoor_category": {
        "garden": "Ogród",
        "null": "Brak",
        "terrace": "Taras",
        "terrace_garden": "Taras + Ogród"
      },
      "status": {
        "available": "Dost.",
        "unavailable": "Niedost."
      },
      "toasts": {
        "activateSuccess": "{unit_name} został pomyślnie aktywowany",
        "create_fixed": "Utworzono jednostkę",
        "create_rundle": "Utworzono nową aktywną jednostkę. Pozostała 1 aktywna jednostka. | Utworzono nową aktywną jednostkę. Pozostało {count} aktywnych jednostek.",
        "deactivateSuccess": "Jednostka {unit_name} została pomyślnie dezaktywowana",
        "delete": "Usunięto jednostkę",
        "update": "Zaktualizowano jednostkę"
      },
      "type": {
        "apartment": "Apartament",
        "cellar": "Piwnica",
        "commercial": "Budynek komercyjny",
        "duplex": "Dom typu bliźniak",
        "house": "Dom",
        "loft": "Loft",
        "office": "Biuro",
        "penthouse": "Penthouse",
        "sme": "Placówka dla małych i średnich przedsiębiorstw",
        "studio": "Studio"
      },
      "validation": {
        "needName": "Należy podać tytuł",
        "needNumber": "Należy podać liczbę (np. 85)",
        "pricesNotUpdatable": "Ceny zostały rozłożone na raty i dlatego nie można ich edytować. Usuń powiązane raty, aby ponownie edytować ceny",
        "totalSalesValueNotEqualToParts": "Wygląda na to, że całkowita wartość sprzedaży nie jest równa sumie jej części"
      }
    }
  }
}
